export default __webpack_public_path__ + "static/media/AI-JJFA.3a30ec0d.png";